<template>
    <div class="upload-wrapper">
        <p class="upload-title mb-0">{{ label }}</p>
        <div class="upload-field "
             v-bind:id="[id]"
        >
            <div class="upload">
                <div class="text-center p-3">
                    <h4>ファイルをドラッグ<br/>または</h4>
                    <file-upload
                            :drop="getBindSelector()"
                            :drop-directory="true"
                            :headers="{
                                'X-CSRF-TOKEN': getCSRFtoken(),
                                'X-XSRF-TOKEN': getXSRFToken(),
                                'Authorization': getAccessToken()
                            }"
                            :input-id="id + '_file'"
                            :multiple="multiple"
                            :post-action="url_store"
                            :ref="id"
                            @input-file="inputFile"
                            class="btn btn-primary"
                            v-model="files"
                    >
                        ファイルを選択する
                    </file-upload>
                </div>
            </div>
            <div class="drop-active" v-show="this.$refs[id] && this.$refs[id].dropActive">
                <h3>ドロップしてファイルをアップロード</h3>
            </div>
            <div class="invalid-feedback d-block">{{ error }}</div>
        </div>
        <div :key="file.id" class="row " v-bind:id="file.id" v-for="(file, index) in files">
            <div class="col-1">
                <v-icon color="red">fiber_new</v-icon>
            </div>
            <div class="col-6">
                <div v-if="file.success"><a target="_blank" v-bind:href="getDownloadUrl(file.response.id)">
                    {{file.name}} </a></div>
                <div v-else>{{file.name}}</div>

                <div class="progress" v-if="file.active || file.progress !== '0.00'">
                    <div :class="{'progress-bar': true, 'progress-bar-striped': true, 'bg-danger': file.error, 'progress-bar-animated': file.active}"
                         :style="{width: file.progress + '%'}" role="progressbar">{{file.progress}}%
                    </div>
                </div>
            </div>

            <div class="col-3" v-if="file.error">アップロード失敗</div>
            <div class="col-3" v-else-if="file.success">アップロード完了</div>
            <div class="col-3" v-else-if="file.active">アップロード中</div>
            <div class="col-3" v-else></div>

            <div class="col-2">
                <button-confirm
                        :func-ok="function() { $refs[id].remove(file) }"
                        classes="btn-danger"
                        label="削除"
                        message="本当に削除してよろしいですか？"
                        title="データを削除しようとしています"
                >
                </button-confirm>
            </div>
        </div>
    </div>
</template>

<script>
    import FileUpload from 'vue-upload-component'

    export default {
        components: {
            FileUpload,
        },
        props: {
            label: String,
            name: String,
            id: String,
            error: String,
            multiple: {
                type: Boolean,
                default: false
            },
            disable_delete: {
                type: Boolean,
                default: false
            },
            front_flg: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                isDrag: false,
                innerFlag: false,
                files: [],
                url_store: "/admin/api/commons/file/upload",
                url_destroy: "/admin/api/commons/file/delete/",
                url_download: "/admin/commons/file/downloadTemporary/",
            }
        },
        mounted() {
            if (this.front_flg) {
                this.url_store = "api/commons/file/upload";
                this.url_destroy = "api/commons/file/delete/0";
                this.url_download = "commons/file/downloadTemporary/0";
            }
        },
        methods: {
            getBindSelector() {
                return "#" + this.id;
            },
            getCSRFtoken() {
                return $('meta[name="csrf-token"]').prop('content');
            },
            getXSRFToken() {
                return Cookies.get('XSRF-TOKEN');
            },
            getAccessToken() {
                return appUtil.getAccessToken();
            },
            getDownloadUrl(id) {
                return this.url_download + id;
            },
            getInputName(id, nameParam) {
                return this.name + '[new][' + id + '][' + nameParam + ']';
            },
            inputFile(newFile, oldFile) {
                // Auto Upload
                if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
                    if (!this.$refs[this.id].active) {
                        this.$refs[this.id].active = true;
                    }
                }

                if (newFile && oldFile) {
                    // Update file

                    // Upload error
                    if (newFile.error !== oldFile.error) {
                        let message = 'アップロードに失敗しました';
                        if (newFile.response instanceof Object && newFile.response.errors.file !== undefined) {
                            message = newFile.response.errors.file[0]
                        }
                        appUtil.showErrorDialog('アップロードエラー', message);
                    }

                    // Uploaded successfully
                    if (newFile.success !== oldFile.success) {
                        let message = 'アップロードに失敗しました';
                        if (newFile.response instanceof Object
                            && newFile.response.errors !== undefined
                            && newFile.response.errors.file !== undefined) {
                            message = newFile.response.errors.file[0]
                        }
                        if (newFile.response.id === undefined) {
                            newFile.success = false;
                            newFile.error = 'denied';
                            appUtil.showErrorDialog('アップロードエラー', message);
                        }
                        let $inputId = '<input type="hidden" name="' + this.getInputName(newFile.response.id, 'file_id') + '" value="' + newFile.response.id + '">';
                        let $inputUpdatedAt = '<input type="hidden" name="' + this.getInputName(newFile.response.id, 'updated_at') + '" value="' + newFile.response.updated_at + '">';
                        $(this.getBindSelector()).append($inputId).append($inputUpdatedAt);
                        this.$emit('uploaded', newFile);
                        $('#' + newFile.id).append($inputId).append($inputUpdatedAt);
                    }
                }

                if (!newFile && oldFile) {
                    if (!this.disable_delete) {
                        // Remove file
                        if (oldFile.success && oldFile.response.id) {
                            let url = this.url_destroy + oldFile.response.id;
                            appUtil.deleteAction(url);
                        }
                    }
                }
            }
        },
    }
</script>

<style scoped>
    .upload-field {
        position: relative;
        padding-top: 1em;
        font-weight: bold;
        color: #6091d3;
        background: #f0f7ff;
        border: dashed 2px #5b8bd0;
        border-radius: 10px;
    }

    .upload-title {
        font-size: 19px;
        color: #95ccff;
        font-weight: bold;
    }

    .drop-active {
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        position: absolute;
        z-index: 9999;
        opacity: .6;
        text-align: center;
        background: #000;
        border-radius: 10px;
    }

    .drop-active h3 {
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
        font-size: 40px;
        color: #fff;
        padding: 0;
    }
</style>